module.exports = __webpack_public_path__ + "static/media/ada.a429378d.svg";